import { render, staticRenderFns } from "./formcanvas.vue?vue&type=template&id=735d882e&"
import script from "./formcanvas.vue?vue&type=script&lang=js&"
export * from "./formcanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports